

import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { fieldsForm, schema } from './fields'
import useForm from 'hooks/useForm';
import { REDIRECT_TO_EVENT } from 'schemas/profile';
import { useMutation } from "@apollo/client";
import ErrorMessage from 'components/ErrorMessage';
import useLogin from 'hooks/useLogin';


import './style.scss';
export default function EmailLoginForm(props) {
    const [loginValues, setLoginValues] = React.useState({
        email: '',
        invitationCode: ''
    });

    const {
        formik,
        renderElementsForm,
        renderElement,
        handleLoadData
    } = useForm({
        fieldsForm,
        schema,
        onSubmit: handleSubmit
    })
    const [message, setMessage] = useState({
        isError: 0,
        text: ""
    });
    const formElements = useMemo(() => renderElementsForm(), [fieldsForm]);
    const [redirectToEvent, { data, error }] = useMutation(REDIRECT_TO_EVENT);
    const { login, loggedIn, status } = useLogin();

    useEffect(() => {
        if(props?.invitecode){
            fieldsForm.invitationCode.placeholder = props.invitecode;
            fieldsForm.invitationCode.value = props.invitecode;
            fieldsForm.invitationCode.className = fieldsForm.invitationCode.className+" disable";
        }
    }, []);

    useEffect(() => {
        if (data) {
            window.location.replace(`${WORDPRESS_URL}?p=${data.redirectToEvent?.body.eventId}`)
        }
    }, [data]);

    useEffect(() => {
        setMessage(status);

        if (loggedIn) {
            redirectToEvent({ variables: { fields: { ...loginValues } } });
        }
    }, [loggedIn, status]);

    function handleSubmit(values) {
        values.invitationCode = values.invitationCode.trim();
        values.type = 'email';
        setLoginValues(values);
        login(values);
    }


    return (
        <div className="lin-login-form">
            <Form onSubmit={formik.handleSubmit}>
                <Row>
                    {message.text && <ErrorMessage isError={message.isError}>{message.text}</ErrorMessage>}
                </Row>
                <Row>
                    <Col className="lin-wrapper">
                        {renderElement(formElements[0])}
                        {renderElement(formElements[1])}
                    </Col>
                </Row>
                <Button as="input" type="submit" value={"login"} />{' '}
            </Form>
        </div >

    )
}